module.exports = __webpack_public_path__ + "static/media/QuickTransfer.18b3fc4d.svg";